import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";

export function RLTemplateHierarchyCountRecursive() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/template-hierarchy-count-recursive.html"),
        controllerAs: "thcVM",
        controller: TemplateHierarchyCountRecursiveController,
        bindToController: true,
        scope: {
            childTemplates: "=childTemplates",
            charTypeID: "=charTypeId"
        }
    };
    return directive;
}

export class TemplateHierarchyCountRecursiveController {
    static $inject = ["$element", "$scope", "$window", "$filter", "$q", "notifyService", "entityService"];

    charTypeID: number;
    childTemplates: Models.ITemplateHierarchy[];

    constructor(
        private $element: ng.IAugmentedJQuery, private $scope: ng.IScope, private $window: ng.IWindowService, private $filter: ng.IFilterService, private $q: ng.IQService, private notifyService: NotifyService,
        private entityService: EntityService) {

    }

    Init() {

    }
}
